<template>
    <modal 
        v-model:show="modal"
        gradient="danger"
        modal-classes="modal-danger modal-dialog-centered"
    >
        <template #header><h6 class="modal-title" id="modal-title-notification">{{ title }}</h6></template>
        <div class="py-3 text-center">
            <i class="ni ni-bell-55 ni-3x"></i>
            <h4 class="heading mt-4">{{ message ? message : $t('common.confirm_action') }}</h4>
        </div>
        <template #footer>
            <base-button type="white" @click="$emit('action')">{{ confirm ? confirm : $t('common.confirm') }}</base-button>
            <base-button type="link"
                class="ml-auto text-white"
                @click="modal = false">
                {{ decline ? decline : $t('common.cancel') }}
            </base-button>
        </template>
    </modal>
</template>

<script>
import Modal from '../../argon/components/Modal';
import BaseButton from '../../argon/components/BaseButton';

export default {
    name: 'ConfirmDialog',
    components: {
        Modal,
        BaseButton
    },
    emits: ['update:modelValue', 'action'],
    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: false
        },
        message: {
            type: String,
            required: false
        },
        confirm: {
            type: String,
            required: false
        },
        decline: {
            type: String,
            required: false
        }
    },
    computed: {
        modal: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    }
}
</script>

<style>

</style>
